import { configureStore } from "@reduxjs/toolkit";
import AuthReducer from "./features/authSlice";
import FormStepperReducer from "./Slices/formStepper";

export default configureStore({
  reducer: {
    auth: AuthReducer,
    formStepper: FormStepperReducer
  }
});
